import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { BadgeComponent } from '@domgen/dgx-fe-components/badge';
import { ButtonComponent } from '@domgen/dgx-fe-components/button';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { PanelComponent } from '@domgen/dgx-fe-components/panel';
import {
  PaymentFrequency,
  USPostHogTrackingEvents,
} from '@us-registration/util-models';
import posthog from 'posthog-js';

@Component({
  selector: 'us-registration-protection-details-purchase-price-option',
  templateUrl: './protection-details-purchase-price-option.component.html',
  styleUrls: ['./protection-details-purchase-price-option.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BadgeComponent,
    ButtonComponent,
    IconComponent,
    NgIf,
    PanelComponent,
  ],
})
export class ProtectionDetailsPurchasePriceOptionComponent implements OnInit {
  @Input() badgeText?: string;
  @Input() buttonText?: string;
  @Input() disclaimer?: string;
  @Input() discountedPrice?: string;
  @Input() newMessage?: string;
  @Input() originalPrice?: string;
  @Input() paymentFrequency?: string;
  @Input() promotionalPriceEnabled = false;
  @Input() showIcon = false;
  @Input() subtitle?: string;
  @Output() buttonClicked = new EventEmitter<boolean>();

  isPrepayPaymentOption = false;

  ngOnInit(): void {
    this.isPrepayPaymentOption =
      this.paymentFrequency === PaymentFrequency.Prepay;
  }

  onButtonClick(): void {
    posthog.capture(
      this.isPrepayPaymentOption
        ? USPostHogTrackingEvents.ProtectionDetailsPageAnnualUpsellCtaClicked
        : USPostHogTrackingEvents.ProtectionDetailsPageMonthlyUpsellCtaClicked
    );
    this.buttonClicked.emit(this.isPrepayPaymentOption);
  }
}
